import React from "react";
import { useTranslation } from "react-i18next";

import { Drawer } from "../../../components/Drawer";
import { useDrawersContext } from "../../tasks/drawers-context";
import { SettingsTags } from "../sections/SettingsTags";

export const SettingsTagsDrawer: React.FC = () => {
  const { t } = useTranslation();
  const { tagsManageVisible, setTagsManageVisible } = useDrawersContext();

  return (
    <Drawer
      open={tagsManageVisible}
      onClose={() => setTagsManageVisible(false)}
      title={t("entries.table.entry.tags.manage")}
      destroyOnHidden
    >
      <SettingsTags inDrawer />
    </Drawer>
  );
};
